export const forError = (value, error) => {
	if (value && error) {
		return true;
	}
	return false;
};
